import React from "react";
import { Outlet } from "react-router-dom";
import DashboardHeader from "../DashboardHeader/DashboardHeader";
import DashboardSidebar from "../DashboardSidebar/DashboardSidebar";
import DashboardFooter from "../DashboardFooter/DashboardFooter";

import "./AdminDashboard.css";
const AdminDashboard = () => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  return (
    <div className="dashboard-layout">
      <DashboardHeader userRole={user?.user?.role_display || "Admin"} />
      <DashboardSidebar userRole={user?.user?.role_display} />
      <main className="main-content">
        <Outlet />
      </main>
      <DashboardFooter />
    </div>
  );
};

export default AdminDashboard;
